import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { getAllPartySpaceDetailAction, insertUpdatePartySpaceDetailAction } from "../../actions/homePageActions/partySpaceDetailAction";

const INITIAL_STATE = {

    getAllPartySpaceDetail: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },

    insertUpdatePartySpaceDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
}

const partySpaceDetailReducer = createSlice({
    name: "Happy Hour Menu",
    initialState: INITIAL_STATE,
    reducers: {


        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetPartySpaceDetailsState(state, action) {
            state.insertUpdatePartySpaceDetails = INITIAL_STATE.insertUpdatePartySpaceDetails;
        },

    },

    extraReducers: (builder) => {
        builder.addCase(getAllPartySpaceDetailAction.fulfilled, (state, action) => {
            // console.log("getAllPartySpaceDetailAction success", action.payload.data);
            state.getAllPartySpaceDetail.data = action.payload.data;
            // console.log(state.getAllPartySpaceDetail.data , 'given data');
            state.getAllPartySpaceDetail.apiMsg.status = action.meta.requestStatus;
            state.getAllPartySpaceDetail.apiMsg.message = "success";
            // console.log(state.getAllPartySpaceDetail.apiMsg.message,'apimsg');
        });
        builder.addCase(getAllPartySpaceDetailAction.pending, (state, action) => {
            // console.log("getAllPartySpaceDetailAction pending", action);
            state.getAllPartySpaceDetail.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllPartySpaceDetailAction.rejected, (state, action) => {
            // console.log("getAllPartySpaceDetailAction rejected", action);
            state.getAllPartySpaceDetail.apiMsg.message = action.error.message;
            state.getAllPartySpaceDetail.apiMsg.status = action.meta.requestStatus;
        });


        //insert update case

        builder.addCase(
            insertUpdatePartySpaceDetailAction.fulfilled,
            (state, action) => {

                state.insertUpdatePartySpaceDetails.data = action.payload.data.data;
                state.insertUpdatePartySpaceDetails.apiMsg.status = action.meta.requestStatus;
                state.insertUpdatePartySpaceDetails.apiMsg.message = action.payload.message.message;

                // console.log(action.payload.data.data, 'reducerdata')

                toast.success(action.payload.message.message, {
                    position: 'bottom-center',
                    toastId: "dept-error"
                });

            }
        );

        builder.addCase(
            insertUpdatePartySpaceDetailAction.pending,
            (state, action) => {
                state.insertUpdatePartySpaceDetails.apiMsg.status = action.meta.requestStatus;
            }
        );

        builder.addCase(
            insertUpdatePartySpaceDetailAction.rejected,
            (state, action) => {

                console.log(action.error.message);
                state.insertUpdatePartySpaceDetails.apiMsg.message = action.error.message;
                state.insertUpdatePartySpaceDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: 'bottom-center',
                    toastId: "dept-error"
                });
            }
        );
    }

})

export const { RESET, ResetPartySpaceDetailsState } = partySpaceDetailReducer.actions;
export default partySpaceDetailReducer.reducer;